import classNames from 'classnames'
import { createElement, forwardRef, PropsWithChildren } from 'react'
import { AsComponentProp, NativeProps } from '../../primitives/types'
import { sprinkles, Sprinkles } from '../../theme/sprinkles.css'

type ComponentProps = Pick<
	Sprinkles,
	| 'fontSize'
	| 'fontWeight'
	| 'lineHeight'
	| 'fontFamily'
	| 'color'
	| 'textDecoration'
	| 'textAlign'
	| 'textTransform'
	| 'fontStyle'
	| 'cursor'
>
type Props = PropsWithChildren<NativeProps & AsComponentProp & ComponentProps>

export const Typography = forwardRef<HTMLElement, Props>(({ component = 'span', className, ...rest }, ref) => {
	const sprinklesProps: Record<string, unknown> = {}
	const nativeProps: Record<string, unknown> = {}

	for (const key in rest) {
		if (sprinkles.properties.has(key as keyof Sprinkles)) {
			sprinklesProps[key] = rest[key as keyof typeof rest]
		} else {
			nativeProps[key] = rest[key as keyof typeof rest]
		}
	}

	return createElement(component, { ref, className: classNames(className, sprinkles(sprinklesProps)), ...nativeProps })
})
